import script from "./StickyScrollbar.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyScrollbar.vue?vue&type=script&setup=true&lang=js"

import "./StickyScrollbar.vue?vue&type=style&index=0&id=43adf387&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43adf387"]])

export default __exports__